<template lang="pug">
.diff.d-flex
  json-compare(:oldData="newest", :newData="oldest")
  json-compare(:oldData="oldest", :newData="newest")
</template>

<style type="text/css">
	.alpaca-p.alpaca-upd , .alpaca-p.alpaca-upd * {
    background-color: black;
	}
</style>

<script>
import JsonCompare from 'vue-json-compare'

export default {
  components: {
    JsonCompare
  },
  props: {
    oldest: { default: () => ({}) },
    newest: { default: () => ({}) }
  }
}
</script>
